import { useContext } from 'react';

import { AppContext } from './context';
import { ConfigProviderProps } from './types';

export const useConfig = (): ConfigProviderProps => useContext(AppContext);
